import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ErrorBoundary } from './components/error';
import './index.css';

/**
 * Spellion Frontend - Entry Point
 * 
 * Main entry point for the Spellion React application.
 * Uses React 18 with StrictMode for development checks,
 * BrowserRouter for SPA navigation, and global ErrorBoundary
 * for catching unexpected errors.
 * 
 * @validates Requirements 1.4, 1.7, 4.5
 */

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element. Please ensure your HTML has a div with id="root".');
}

/**
 * Error handler for logging errors to external services
 * In production, this could send errors to Sentry, LogRocket, etc.
 */
const handleError = (error: Error, errorInfo: React.ErrorInfo) => {
  // Log to console in all environments
  console.error('Application error:', error);
  console.error('Component stack:', errorInfo.componentStack);
  
  // TODO: In production, send to error tracking service
  // if (import.meta.env.PROD) {
  //   errorTrackingService.captureException(error, { extra: errorInfo });
  // }
};

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <ErrorBoundary onError={handleError}>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </StrictMode>
);
